import { HTTP_CP_ProvideClientUserSignInCode_Request } from '@api-new/authservice';
import { HTTP_CP_LoadSignInBranding_Response } from '@api-new/companyservice';
import { environment } from '@environments/environment';

export const sendVerificationCodeRequestAdapter = (
  email: string,
  branding?: HTTP_CP_LoadSignInBranding_Response,
  signInCompanyId?: string | null,
): HTTP_CP_ProvideClientUserSignInCode_Request => {
  if (environment.mobileApp?.isMobileApp) return { email, signInNetworkId: environment.mobileApp.signInNetworkId };
  if (signInCompanyId) return { email, signInCompanyId };

  return {
    email,
    ...(branding?.signInCompanyId && { signInCompanyId: branding.signInCompanyId }),
    ...(branding?.signInNetworkId && { signInNetworkId: branding.signInNetworkId }),
  };
};
